export default __webpack_public_path__ + "assets/media/favicon152.6107239f3bb2bd83ce309b1cf71a6e21.png";